
import { SanityFile } from '@nuxtjs/sanity/dist/components/sanity-file';
import SVGwinemenu from '../../assets/svg/winemenu.svg';
import SVGmenu from '../../assets/svg/menu.svg';
import SVGdrink from '../../assets/svg/drink.svg';
import SVGspecialities from '../../assets/svg/specialities.svg';
import SVGweeklyMenu from '../../assets/svg/weeklyMenu.svg';
import SVGevent from '../../assets/svg/event.svg';

export default {
  components: {
    SVGmenu,
    SVGwinemenu,
    SVGdrink,
    SVGspecialities,
    SVGevent,
    SVGweeklyMenu,
    SanityFile
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isSafari() {
      let safariAgent = false;
      if (process.client) {
        const userAgentString = navigator.userAgent;
        safariAgent = userAgentString.includes('Safari');
        const chromeAgent = userAgentString.includes('Chrome');

        // Discard Safari since it also matches Chrome
        if (chromeAgent && safariAgent) {
          safariAgent = false;
        }
      }
      return Boolean(safariAgent);
    }
  }
};
